import { Skeleton } from "@/components/ui/skeleton"

export default function InlineLoader() {
  return (
    <output
      className="w-full flex-1 flex items-center justify-center"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-24" />
      </div>
    </output>
  )
}
